export const ADD_VENDEDOR = 'channelmap/reporteparticipacion/add_vendedor';
export const RECEIVE_DATA = 'channelmap/reporteparticipacion/receive_data';
export const RESTART_STATE = 'channelmap/reporteparticipacion/restart_state';
export const SET_MASK = 'channelmap/reporteparticipacion/set-mask';
export const UPDATE_FIELD_FILTER = 'channelmap/reporteparticipacion/update-field-filter';
export const UPDATE_OLA_FIELD_FILTER = 'channelmap/reporteparticipacion/update-ola-field-filter';
export const UPDATE_DIST_FIELD_FILTER = 'channelmap/reporteparticipacion/update-dist-field-filter';